import { Model } from 'backbone';

const ATTRIBUTES = Object.freeze({
	id: 'id',
	selectedOptionId: 'selectedOptionId',

	/** RUNTIME ATTRIBUTES */
	timesAnswered: 'timesAnswered',
});

export { ATTRIBUTES };

export default class BaseRound extends Model {
	defaults() {
		return {
			[ATTRIBUTES.id]: undefined,
			[ATTRIBUTES.selectedOptionId]: undefined,
			[ATTRIBUTES.timesAnswered]: 0,
		};
	}
}
